import { render, staticRenderFns } from "./TurnoverPercentagePerBranchCurrentYearInformation.vue?vue&type=template&id=7ba04257&"
import script from "./TurnoverPercentagePerBranchCurrentYearInformation.vue?vue&type=script&lang=ts&"
export * from "./TurnoverPercentagePerBranchCurrentYearInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports